import request from "../request";
import { MessagePayload } from "../../types/messagePayload";

export const postFeedback = (data: MessagePayload) => request<MessagePayload>({
    method: "POST",
    uri: "feedback",
    data,
});
